import React, { createContext, useContext, useState } from "react";
import format from 'date-fns/format';

const DateContext = createContext();

export function DateProvider({ children }) {
    const today = new Date();
    const startOfWeek = new Date(today);
    startOfWeek.setDate((today.getDate() - today.getDay()) - 7); // Start of the last week (Sunday).
    const startOfWeekFormat = format(startOfWeek, 'yyyy-MM-dd');
    const endOfWeek = new Date(today);
    endOfWeek.setDate((today.getDate() + (6 - today.getDay()) - 7)); // End of the last week (Saturday).
    const endOfWeekFormat = format(endOfWeek, 'yyyy-MM-dd');
        
  const [selectedDate, setSelectedDate] = useState([
    {
        startDate: startOfWeek,
        endDate: endOfWeek,
        key: 'selection',
        dateString: `${startOfWeekFormat}..${endOfWeekFormat}`
    }
  ]);

  return (
    <DateContext.Provider value={{ selectedDate, setSelectedDate }}>
      {children}
    </DateContext.Provider>
  );
}

export function useDate() {
  return useContext(DateContext);
}
